import * as React from 'react';
import RectImgBox from './BrotherCard';
import './BrotherCard.css';

import Stack from '@mui/material/Stack';

//Pi class
import Aden_Lok from '../../media/Brothers/Headshots/Pi/Aden_Lok.JPG';
import Adithi_Chitiprolu from '../../media/Brothers/Headshots/Pi/Adithi_Chitiprolu.jpeg';
import Ariyana_Rahman from '../../media/Brothers/Headshots/Pi/Ariyana_Rahman.jpg';
import Audrey_Xiang_Wang from '../../media/Brothers/Headshots/Pi/Audrey_Xiang_Wang.JPG';
import Eric_Zhao from '../../media/Brothers/Headshots/Pi/Eric_Zhao.JPG';
import Noah_Robitshek from '../../media/Brothers/Headshots/Pi/Noah_Robitshek.JPG';
import Parthi_Mashru from '../../media/Brothers/Headshots/Pi/Parthi_Mashru.JPG';
import Peter_Zhao from '../../media/Brothers/Headshots/Pi/Peter_Zhao.JPG';
import Shamir_Lorenzo_Legaspi from '../../media/Brothers/Headshots/Pi/Shamir_Lorenzo_Legaspi.JPG';
import Thomas_Tran from '../../media/Brothers/Headshots/Pi/Thomas_Tran.JPG';
import Zubin_Gu from '../../media/Brothers/Headshots/Pi/Zubin_Gu.JPG';


const Pi = () => {
  const piClass = [
    {broname: "Aden Lok", src: Aden_Lok, alt: "Aden Lok", majorGrad: "Mechanical Engineering '26"},
    {broname: "Adithi Chitiprolu", src: Adithi_Chitiprolu, alt: "Adithi Chitiprolu", majorGrad: "Biomedical Engineering '26"},
    {broname: "Ariyana Rahman", src: Ariyana_Rahman, alt: "Ariyana Rahman", majorGrad: "Biomedical Engineering '26"},
    {broname: "Audrey Xiang Wang", src: Audrey_Xiang_Wang, alt: "Audrey Wang", majorGrad: "Mechanical Engineering '26"},
    {broname: "Eric Zhao", src: Eric_Zhao, alt: "Eric Zhao", majorGrad: "Computer Engineering '25"},
    {broname: "Noah Robitshek", src: Noah_Robitshek, alt: "Noah Robitshek", majorGrad: "Computer Engineering '25"},
    {broname: "Parthi Mashru", src: Parthi_Mashru, alt: "Parthi Mashru", majorGrad: "Biomedical Engineering '26"},
    {broname: "Peter Zhao", src: Peter_Zhao, alt: "Peter Zhao", majorGrad: "Computer Engineering '26"},
    {broname: "Shamir Lorenzo Legaspi", src: Shamir_Lorenzo_Legaspi, alt: "Shamir Legaspi", majorGrad: "Computer Engineering '25"},
    {broname: "Thomas Tran", src: Thomas_Tran, alt: "Thomas Tran", majorGrad: "Mechanical Engineering '25"},
    {broname: "Zubin Gu", src: Zubin_Gu, alt: "Zubin Gu", majorGrad: "Mechanical Engineering '25"},
  ];
  return (
    <div className = "Classes">
      {piClass.map((photo, index) => (
        <RectImgBox
        key = {index}
        broname = {photo.broname}
        src = {photo.src}
        alt = {photo.alt}
        majorGrad = {photo.majorGrad}
        />
      ))}
    </div>
  );
};

export default Pi;